<template>
  <div class="home">
    <div class="pa-4" v-bind:style="{background: $vuetify.theme.themes.dark.highlight}">
        <v-img
              alt="MacDaddy Services"
              :src="require('@/assets/services.svg')"
              transition="scale-transition"
              class="app-hero-banner-img"
            />
    </div>
    <div class="d-flex justify-center align-content-top flex-wrap" v-bind:style="{background: $vuetify.theme.themes.dark.secondary}">
        <v-card class="pa-4" color="secondary" outlined tile>
            <v-card-title class="headline mb-4">MacDaddy</v-card-title>
            <v-card-subtitle>
                Fort Bragg's best Mac and PC store.<br />Computer Repair and Sales, Apple, Windows, iPhone, iPad.
            </v-card-subtitle>
            <v-card-actions>
                <v-btn
                    text
                    color="blue"
                    href="https://www.google.com/maps/place/MacDaddy/@39.4444701,-123.8084916,17z/data=!4m12!1m6!3m5!1s0x80803548b861e481:0xf4c85668f64ddd67!2sMacDaddy!8m2!3d39.4444701!4d-123.8063029!3m4!1s0x80803548b861e481:0xf4c85668f64ddd67!8m2!3d39.4444701!4d-123.8063029"
                    >Get Directions.</v-btn>
            </v-card-actions>
        </v-card>

        <v-card class="pa-4" color="secondary" outlined tile>
            <v-card-title class="headline mb-4">Business Hours</v-card-title>
            <v-card-subtitle>
                Monday - Friday, 8am to 2pm<br />
            </v-card-subtitle>
        </v-card>

        <v-card class="pa-4" color="secondary" outlined tile>
            <v-card-title class="headline mb-4">Network/I.T.</v-card-title>
            <v-card-subtitle>
                We serve Fort Bragg and Mendocino.
            </v-card-subtitle>
        </v-card>
        <v-card class="pa-4" color="secondary" outlined tile>
            <v-card-title class="headline mb-4">Web Design</v-card-title>
            <v-card-subtitle>
                Quality web design and eCommerce solutions.
            </v-card-subtitle>
            <v-card-actions>
                <v-btn
                    :to="'portfolio'"
                    @click.native="$scrollBehaviour"
                    text
                    color="blue">See Portfolio.</v-btn>
            </v-card-actions>
        </v-card>
        <!-- <v-card outlined tile color="secondary" class="flex-grow-1 flex-shrink-0"></v-card> -->
    </div>

    <div class="pa-4" v-bind:style="{background: $vuetify.theme.themes.dark.highlight}">
        <v-img
            alt="MacDaddy, 301 N Main St, Fort Bragg, CA 95437"
            :src="require('@/assets/macdaddy-office.jpg')"
            transition="scale-transition"
            />
    </div>
  </div>
</template>
<style type="scss">
    
@media (max-width: 400px) {
    .app-hero-banner-img {
        min-height: 100px;
    }
}
@media (min-width: 400px) and (max-width: 600px ) {
    .app-hero-banner-img {
        min-height: 150px;
    }
}
@media (min-width: 600px) and (max-width: 720px ) {
    .app-hero-banner-img {
        min-height: 220px;
    }
};
@media (min-width: 720px) and (max-width: 960px ) {
    .app-hero-banner-img {
        min-height: 280px;
    }
};
@media (min-width: 960px) and (max-width: 1264px ) {
    .app-hero-banner-img {
        min-height: 340px;
    }
}

@media (min-width: 1264px) {
    .app-hero-banner-img {
        min-height: 440px;
    }
}

</style>
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    // HelloWorld
  }
}
</script>
